<template>
    <views>
        <views class="search">
            <views class="search-left">
                <views class="search-content">
                    <views class="search-icon">
                        <images :src="searchIcon"></images>
                    </views>
                    <views class="search-input">
                        <!-- form ios手机上唤起搜索按钮（默认是换行按钮）  -->
                        <form action="javascript:return true">
                            <input
                                v-focus
                                v-model="keyword"
                                :placeholder="placeholderTitle"
                                autofocus
                                type="search"
                                @keypress="searchBtn"
                                @input="inputChange()"
                            />
                        </form>
                    </views>
                </views>
            </views>
            <views class="search-right" @click="handleCancel">取消</views>
        </views>
        <views v-if="shopList.length > 0" class="shop-list">
            <views
                v-for="(item, index) in shopList"
                :key="index"
                class="list"
                @click="goMap(item)">
                {{ item.name }}
            </views>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    mixins: [tools],
    data() {
        return {
            keyword: '',
            searchIcon: require('@/assets/images/sy_ss@3x.png'),
            shopList: []
        }
    },
    computed: {
        querys() {
            return this.$route.query
        },
        placeholderTitle() {
            return this.querys.placeholder ? this.querys.placeholder : '请输入搜索标题'
        }
    },
    watch: {
        'querys.keyword': {
            handler(val) {
                if (val) this.keyword = val
            },
            immediate: true
        }
    },
    methods: {
        goMap(row) {
            const url = `/map-navigation?&endLng=${row.longitude}&endLat=${row.latitude}&toName=${row.name}&posP=${row.province}&posC=${row.city}&pid=${row.provinceId}&cid=${row.cityId}`
            this.windowReplace(url)
        },
        inputChange() {
            const searchVal = event.target.value
            if (this.querys.to === 'map-navigation') {
                api.getShopList({ name: searchVal }).then((res) => {
                    if (res.data.list) {
                        this.shopList = res.data.list
                    }
                })
            }
        },
        searchBtn(event) {
            if (event.keyCode === 13) { // 如果按的是enter键 13是enter
                event.preventDefault() // 禁止默认事件（默认是换行）
                const searchVal = event.target.value
                const { to, categoryId, categoryName } = this.querys
                let url = ''
                if (to === 'map-navigation') {
                    this.inpurChange(event)
                } else {
                    if (to === 'faq') {
                        url = `/${to}?keyword=${searchVal}`
                    } else {
                        if (categoryName && categoryId) {
                            url = `/${to}?categoryName=${categoryName}&categoryId=${categoryId}&keyword=${searchVal}`
                        } else {
                            url = `/${to}?keyword=${searchVal}`
                        }
                    }
                    this.replace(url)
                }
            }
        },
        handleCancel() {
            const { from, to, categoryId, categoryName, endLng, endLat, toName } = this.querys
            let url = ''
            if (from) {
                url = `/${from}`
            } else {
                if (to === 'faq') {
                    url = `/${to}`
                } else if (to === 'map-navigation') {
                    url = `/${to}?&endLng=${endLng}&endLat=${endLat}&toName=${toName}`
                } else {
                    url = `/${to}?categoryName=${categoryName}&categoryId=${categoryId}`
                }
            }
            this.replace(url)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
